"use client"

import { useFormStatus } from "react-dom"

interface SubmitButtonProps {
  label?: string
  pendingLabel?: string
  className?: string
}

export default function SubmitButton({
  label = "Submit",
  pendingLabel = "Submitting...",
  className = "w-full rounded-lg bg-amber-500 px-6 py-3 text-sm font-semibold text-white hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 disabled:opacity-50 transition-colors",
}: SubmitButtonProps) {
  const { pending } = useFormStatus()

  return (
    <button type="submit" disabled={pending} className={className}>
      {pending ? pendingLabel : label}
    </button>
  )
}
